import React from "react";
import {
  safeFormat,
  formatLabel,
  toWholeNumber,
} from "../../../../utils/financialHelper";

import "./keyFacts.less";

type Fact = { value: string | number; label: string };

interface KeyFactsProps {
  facts: Fact[];
  summary: string;
  sponsor: string;
  title?: string;
}

const KeyFacts: React.FC<KeyFactsProps> = ({
  facts,
  summary,
  sponsor,
  title = "Key Facts",
}) => {
  return (
    <section className="keyfacts">
      <div className="keyfacts__card">
        {/* LEFT */}
        <div className="keyfacts__left">
          <h1 className="keyfacts__title">{title}</h1>

          <div className="keyfacts__list">
            {facts.map((fact, idx) => (
              <div
                className={`keyfacts__item ${
                  idx === facts.length - 1 ? "keyfacts__item--last" : ""
                }`}
                key={idx}
              >
                <div className="keyfacts__value">
                  {fact.label === "Market Capitalisation"
                    ? toWholeNumber(fact.value)
                    : typeof fact.value === "number"
                    ? safeFormat(fact.value)
                    : fact.value}
                </div>

                <p className="keyfacts__label">{formatLabel(fact.label)}</p>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="keyfacts__right">
          <h4 className="keyfacts__heading">Introduction</h4>
          <p className="keyfacts__text">
            {summary.split("\n").map((line, idx) => (
              <span key={idx}>
                {line}
                <br />
              </span>
            ))}
          </p>

          <h3 className="keyfacts__heading">Sponsor & Sponsor group</h3>
          <p className="keyfacts__text">{sponsor}</p>
        </div>
      </div>
    </section>
  );
};

export default KeyFacts;
